import { http } from '../http';
import { Params } from '@/facilities/model/user';

export const getChronicLiftsCnt = async (params: Params) => {
  return await http.get('/api/reports/chronic-lifts/cnt', params);
};

export const getLiftReportDetail = async (id: string) => {
  return await http.get(`/api/reports/chronic-lifts/${id}/detail`);
};

export const getProperOrg = async (params: Params) => {
  return await http.get('/api/properties/org', { params });
};
